import moment from 'moment';

export const getLocalFullDate = dateTime => !dateTime && dateTime !== 0 ? '' : moment(dateTime).format('DD.MM.YYYY HH:mm');
